export default __webpack_public_path__ + "static/media/parking-mockup.1cb18d86.png";